define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../models/UserContext", "../../shared/dataLogs", "./employeeActions", "./commissionRoleActions", "../../models/EmployeeModel"], function (require, exports, $, ko, log, urls_1, tools, UserContext, DataLogs, EmployeeActions, CommissionRoleActions, EmployeeModel) {
    "use strict";
    var EmployeeDetails = /** @class */ (function () {
        function EmployeeDetails() {
            this.userCanViewRole = ko.observable(UserContext.hasAccess("Admin,CommissionRole.View,CommissionRole.Edit,CommissionRole.Delete"));
            this.userCanAddRole = ko.observable(UserContext.hasAccess("Admin,CommissionRole.Edit,CommissionRole.Delete"));
            this.userCanEditEmployee = ko.observable(UserContext.hasAccess("Admin,Employee.Edit,Employee.Delete"));
            this.userCanDeleteEmployee = ko.observable(UserContext.hasAccess("Admin,Employee.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new EmployeeModel());
        }
        EmployeeDetails.prototype.init = function (id) {
            var self = this;
            $("#page-title").text("Member Details");
            var getModelCall = self.getEmployeeById(id);
            $.when(getModelCall).done(function () {
                self.employeeActions = new EmployeeActions();
                self.employeeActions.afterSuccess = function () {
                    self.getEmployeeById(id);
                };
                if (self.userCanViewRole()) {
                    self.commissionRoleActions = new CommissionRoleActions(id);
                    self.commissionRoleActions.afterSuccess = function () {
                        self.commissionRoleActions.commissionRoleTable.refresh();
                    };
                    self.commissionRoleActions.initRolesList();
                }
                ko.applyBindings(self, document.getElementById("main-container"));
                $("#contextLoader").hide();
                $("#mainContext").show();
            });
        };
        EmployeeDetails.prototype.getEmployeeById = function (id) {
            var self = this;
            return tools.ajaxGet({
                url: "/Employee/GetEmployeeById",
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new EmployeeModel(result.Data));
                    }
                }
            });
        };
        EmployeeDetails.prototype.addRole = function () {
            var self = this;
            self.commissionRoleActions.editCommissionRole();
        };
        EmployeeDetails.prototype.addEmployee = function () {
            var self = this;
            self.employeeActions.editEmployee();
        };
        EmployeeDetails.prototype.editEmployee = function () {
            var self = this;
            self.employeeActions.editEmployee(self.editModel().Id());
        };
        EmployeeDetails.prototype.showLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Employee", self.editModel().Id());
                dataLogs.open("Member logs");
            }
        };
        return EmployeeDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Employee/Details")) {
            var id = urls_1.urls.getIdFromQueryString();
            if (id <= 0) {
                id = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize Employee details");
            $(function () {
                (new EmployeeDetails()).init(id);
            });
        }
    }, 0);
    return EmployeeDetails;
});
//# sourceMappingURL=employeeDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/employee/employeeDetails.js
// module id = 298
// module chunks = 2